import React,{useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Container, Button, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getProductDetail, addProduct } from '../../../actions/productsActions'
import FormProduct from '../../admin/products/FormProduct'
import Swal from 'sweetalert2'

export default function ProductInsert() {     
    const { t } = useTranslation()
    const {id} = useParams()
    const {product} = useSelector(state=>state.products)
    const dispatch = useDispatch()

    const [formState, setFormState] = useState({})
    const {name, matter} = formState

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleAdd = async(e) => {
        e.preventDefault()

        dispatch(addProduct(name, matter))
        setFormState({
            name: '',
            matter: ''
        })
        
        Swal.fire({
            showConfirmButton: true,
            icon: 'success',
            text: t('products.add')
        })
    }

    useEffect(()=>{
        dispatch(getProductDetail(id))
    }, [dispatch,id])

    useEffect(() => {
        if (product) {
            setFormState({
                name: '',
                matter: ''
            })
        }
    }, [product, dispatch, id])
  
    return (
        <Container className='cuerpo'>
            <Row className="text-left custom-card-header-list">
                <Row className="custom-card-buttom">
                    <Button className="btn btn-secondary mb-4 mx-auto" href={`/admin/products`}>
                        <i className="fas fa-arrow-circle-left"></i> {t('products.volver')}
                    </Button>
                </Row>
                <h1>{t('products.add')}</h1>
                <FormProduct submit={handleAdd} isNew={true} inputChange={handleInputChange} state={formState}></FormProduct>
            </Row>
        </Container>
    )
}
